import { FormEngineModule } from './../../../form/form-engine.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AppComponentCoreModule } from '../core/app-component-core.module';
import { TopbarComponent } from './topbar/topbar.component';
import { MainBarComponent } from './mainbar/mainbar.component';
import { StatusbarComponent } from './statusbar/statusbar.component';
import { FootbarComponent } from './footbar/footbar.component';
import { ActionButtonComponent } from './action-button/action-button.component';
import { ExcelEdoComponent } from './excel-edo/excel-edo.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AppComponentCoreModule,

  ],
  declarations: [
    TopbarComponent,
    MainBarComponent,
    StatusbarComponent,
    FootbarComponent,
    ActionButtonComponent,
    ExcelEdoComponent,
  ],
  exports: [
    AppComponentCoreModule,
    TopbarComponent,
    MainBarComponent,
    StatusbarComponent,
    FootbarComponent,
    ActionButtonComponent,
    ExcelEdoComponent,
  ]
})
export class AppComponentUIModule { }



// WEBPACK FOOTER //
// ./src/app/core/component/ui/app-component-ui.module.ts